import React, { FC, useEffect } from "react";
import { companyInfoFields } from "./clientAllFields";
import {
  Box,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import FormField from "../../../../components/common/FormField";
import ImageUploader from "../../../../components/common/imageUploader/ImageUploader";
import uploadImg from "../../../../assets/images/uploadImg.png";
import { useDispatch } from "react-redux";
import {
  getCheckUniqueCompanyNameAction,
  getCheckUniqueEmailAction,
  getCheckUniqueVatAction,
  setCheckUniqueCompanyNameAction,
  setCheckUniqueVatAction,
  setNewClientLocal,
} from "../../../../store/reducers/adminClientsSlice";
import { useSelector } from "react-redux";

interface ManageCompanyInfoProps {
  selectClient: any; // Adjust type as per your requirement
  companyProfileError: any;
  formData?: any;
  setFormData?: any;
  checkValidator?: any;
  resetValidator?: any;
  action?: any;
  isImageReset?: any;
  setCountryCode?: any;
  countryCode?: any;
  setIsRegNo?: any;
  isRegNo?: any;
}
const CompanyInfoForm: FC<ManageCompanyInfoProps> = ({
  selectClient,
  companyProfileError,
  formData,
  setFormData,
  checkValidator,
  resetValidator,
  action,
  isImageReset,
  setCountryCode,
  countryCode,
  setIsRegNo,
  isRegNo,
}) => {
  const handleImageUpload = (image: string | null) => {
    console.log("Uploaded image:", image);
  };

  const dispatch = useDispatch();

  const { userProfile } = useSelector((state: any) => state?.user);

  const {
    newClientLocal,
    isUniqueCompanyNameError,
    isUniqueVatError,
    editClientOriginalData,
  } = useSelector((state: any) => state?.adminClients);

  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;

    let transformedValue: string | number = value.trim() ? value : value.trim();

    dispatch(
      setNewClientLocal({
        // ...newClientLocal,
        companyProfile: {
          ...newClientLocal?.companyProfile,
          [id]: transformedValue,
        },
        ...(id === "address" &&
          newClientLocal?.financialInformation?.isSameWithCompanyAddress && {
            financialInformation: {
              ...newClientLocal?.financialInformation,
              invoiceAddress: transformedValue,
            },
          }),
      })
    );

    setFormData((prevValues: any) => ({
      ...prevValues,
      [id]: transformedValue,
    }));
    resetValidator(event.target.id);
    if (id === "companyName") {
      dispatch(setCheckUniqueCompanyNameAction(false));
    } else if (id === "vatRegNo" && value !== "") {
      dispatch(setCheckUniqueVatAction(false));
    }
    // }
  };

  const onBlurAction = (e: any) => {
    const { id, value } = e.target;
    checkValidator(e.target.id);
    if (id === "companyName" && value.trim() !== "") {
      if (action === "edit") {
        if (
          editClientOriginalData?.company_name !==
          newClientLocal?.companyProfile?.companyName
        ) {
          dispatch(getCheckUniqueCompanyNameAction(value));
        }
      } else {
        dispatch(getCheckUniqueCompanyNameAction(value));
      }
    } else if (id === "vatRegNo" && value.trim() !== "") {
      if (action === "edit") {
        if (
          editClientOriginalData?.vat_reg_no !==
          newClientLocal?.companyProfile?.vatRegNo
        ) {
          dispatch(getCheckUniqueVatAction(value));
        }
      } else {
        dispatch(getCheckUniqueVatAction(value));
      }
    }
  };

  const handleRadioChange = (event: any) => {
    const { value } = event.target;
    setIsRegNo(value === "yes" ? true : false);
  };

  useEffect(() => {
    resetValidator("vatRegNo");
    resetValidator("vatPercent");
  }, [isRegNo]);

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        mr={4}
        mb={1}
      >
        {!isImageReset && (
          <ImageUploader
            defaultImage={userProfile?.logo || uploadImg}
            onImageUpload={handleImageUpload}
            width={60}
            height={60}
            page="client"
          />
        )}
        <Typography
          sx={{ color: "#333333", fontWeight: 600 }}
          mb={1}
          variant="h6"
        >
          Logo
        </Typography>
      </Box>
      <Box
        sx={{
          background: "#E5F4F1",
          paddingRight: "16px",
          paddingTop: "10px",
          border: "1px solid #CFCFCF",
          borderRadius: "5px",
        }}
      >
        {companyInfoFields?.map((field, i) => {
          // Conditionally render fields based on Reg No radio button
          if (
            !isRegNo &&
            (field.id === "vatRegNo" || field.id === "vatPercent")
          ) {
            return null; // Hide fields if Reg No is set to "No"
          }
          return (
            !selectClient && (
              <>
                {field?.type === "radio" ? (
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "18px !important",
                        paddingTop: "6px !important",
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: 600, fontSize: "12px", mr: 2 }}
                      >
                        {field?.label}
                      </Typography>
                      <RadioGroup
                        row
                        value={isRegNo ? "yes" : "no"}
                        onChange={handleRadioChange}
                      >
                        <FormControlLabel
                          sx={{ fontSize: "14px" }}
                          value="yes"
                          control={<Radio size="small" disabled />}
                          label="Yes"
                        />
                        <FormControlLabel
                          sx={{ fontSize: "14px" }}
                          value="no"
                          control={<Radio size="small" disabled />}
                          label="No"
                        />
                      </RadioGroup>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container spacing={2} key={i}>
                    <FormField
                      onPaste={(e) =>
                        field?.id === "companyName" ||
                        field?.id === "clientName" ||
                        field?.id === "address" ||
                        field?.id === "correspondingAddress" ||
                        field?.id === "companyRegNo" ||
                        field?.id === "generalWebsite" ||
                        field?.id === "postCode" ||
                        field?.id === "transportCode" ||
                        field?.id === "correspondingPostCode"
                          ? ""
                          : e.preventDefault()
                      }
                      onKeyDown={(event: any) => {
                        console.log(
                          "event log-",
                          event,
                          event.target.value + event.key
                        );
                        if (
                          event.keyCode === 8 ||
                          event.keyCode === 9 ||
                          event.keyCode === 37 ||
                          event.keyCode === 38 ||
                          event.keyCode === 39 ||
                          event.keyCode === 40 ||
                          event.keyCode === 18 ||
                          event.keyCode === 17 ||
                          event.ctrlKey
                        )
                          return event;
                        if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(event.key)
                        ) {
                          event.preventDefault();
                        } else if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(
                            event.target.value + event.key
                          )
                        ) {
                          event.preventDefault();
                        }
                      }}
                      {...{
                        ...field,
                        value: newClientLocal?.companyProfile
                          ? field?.id === "phoneNumber"
                            ? newClientLocal?.companyProfile?.phoneNumber?.replace(
                                /^(\+91|\+44)/,
                                ""
                              )
                            : newClientLocal?.companyProfile[field?.id]
                          : "",
                        disabled: field?.editReadOnly,
                        
                        inSingleGridForm: true,
                        isNonMarginTop: true,
                        ...{
                          variant: "outlined", // Adding this variant prop
                          onCountryCodeChange:
                            field.type === "contact" // Example of checking if it's a country code field
                              ? (code: string) => setCountryCode(code)
                              : undefined, // or you could pass a default function if necessary
                          ...{
                            ...(field?.type === "contact" && {
                              countryCode: newClientLocal?.companyProfile[
                                field.id
                              ]
                                ? countryCode
                                : "",
                            }),
                          },
                          multiline:
                            (field?.id === "address" ||
                              field?.id === "correspondingAddress" ||
                              field?.id === "companyStrapLine") &&
                            true,
                          onChange: onChangeAction,
                          onBlur: onBlurAction,
                          InputProps: {
                            // ...field?.max && {min: 0, max: field?.max},
                            ...(field?.inputProps && field?.inputProps),
                            sx:
                              field?.type === "text"
                                ? {
                                    height:
                                      (field?.id === "address" ||
                                        field?.id === "correspondingAddress" ||
                                        field?.id === "companyStrapLine") &&
                                      newClientLocal?.companyProfile[field?.id]
                                        ?.length > 2
                                        ? "auto"
                                        : "36px",
                                    padding:
                                      field?.id === "address" ||
                                      field?.id === "correspondingAddress" ||
                                      field?.id === "companyStrapLine"
                                        ? "4px"
                                        : "",
                                  }
                                : { padding: "10px 4px", height: "36px" },
                          },
                          error:
                            field?.id === "companyName" &&
                            isUniqueCompanyNameError
                              ? true
                              : field?.id === "vatRegNo" && isUniqueVatError
                              ? true
                              : // : field?.id === "phoneNumber"
                                //   ? false
                                companyProfileError &&
                                companyProfileError[field?.id],
                          selectedValues: formData[field?.id],
                        },
                      }}
                    />
                  </Grid>
                )}
              </>
            )
          );
        })}
      </Box>
    </>
  );
};
export default CompanyInfoForm;
